export default __webpack_public_path__ + "static/media/Days_02.5dfb347d.png";